import type { TypeChildren, TypeClassName } from '@/types';

export const enum TagVariant {
  INFO = 'INFO',
  PROMO = 'PROMO',
  SERVICE = 'SERVICE',
  /**
   * Etiqueta "¡Nuevo!" estilo Figma HoM: usa el SVG `markhighlight`
   * (`/assets/images/mark-highlight.svg`)
   */
  MARKHIGHLIGHT = 'MARKHIGHLIGHT',
}

export interface TypeTagProps extends TypeClassName, TypeChildren {
  /**
   * Colores del tag
   */
  variant: TagVariant;
}
